__turbopack_context__.v({
  "activeItem": "notification-bell-module__1Ips0W__activeItem",
  "activePct": "notification-bell-module__1Ips0W__activePct",
  "activeSecondary": "notification-bell-module__1Ips0W__activeSecondary",
  "activeSection": "notification-bell-module__1Ips0W__activeSection",
  "activeStage": "notification-bell-module__1Ips0W__activeStage",
  "activeStageRow": "notification-bell-module__1Ips0W__activeStageRow",
  "activeTag": "notification-bell-module__1Ips0W__activeTag",
  "activeTitle": "notification-bell-module__1Ips0W__activeTitle",
  "activeTitleRow": "notification-bell-module__1Ips0W__activeTitleRow",
  "empty": "notification-bell-module__1Ips0W__empty",
  "emptyMedallion": "notification-bell-module__1Ips0W__emptyMedallion",
  "emptyText": "notification-bell-module__1Ips0W__emptyText",
  "footer": "notification-bell-module__1Ips0W__footer",
  "list": "notification-bell-module__1Ips0W__list",
  "markAllButton": "notification-bell-module__1Ips0W__markAllButton",
  "popoverHeader": "notification-bell-module__1Ips0W__popoverHeader",
  "popoverTitle": "notification-bell-module__1Ips0W__popoverTitle",
  "sectionLabel": "notification-bell-module__1Ips0W__sectionLabel",
  "viewAll": "notification-bell-module__1Ips0W__viewAll",
});
